import { FlowsQuestionAnswer } from '@flows/src/types/FlowsTypes';
import { useMutation, UseMutationOptions } from 'react-query';
import { Car } from '../../../../types/SMT';
import { wgApi } from '../../../app/src/features/api/wgApi';

interface Params {
  queryOptions?: UseMutationOptions<
    AnvaQuoteRecalucateResponse,
    unknown,
    FuncParams
  >;
}

type Payload = {
  car: Car;
  question_id: string;
  index?: number;
};

type FuncParams = {
  sessionId?: string;
  payload: Payload;
};

export type AnvaQuoteRecalucateResponse = {
  questions: FlowsQuestionAnswer[];
};

export const postQuestionPrefillByCar = async ({
  sessionId,
  payload,
}: FuncParams) => {
  const { data, isError } = await wgApi.post<AnvaQuoteRecalucateResponse>(
    `/v1/api/conversations/${sessionId}/generate-questions-to-prefill-by-car`,
    payload,
  );
  if (isError) throw new Error();
  return data;
};

export const useQuestionPrefillByCar = ({ queryOptions = {} }: Params) => {
  return useMutation<AnvaQuoteRecalucateResponse, unknown, FuncParams>(
    postQuestionPrefillByCar,
    {
      ...queryOptions,
    },
  );
};
